module.exports = __webpack_public_path__ + "static/img/mtjz01.7ea668b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/mtjz01.png
// module id = ouy4
// module chunks = 11